<template>
  <div>
    <keep-alive>
      <component :is="enter" :changes="changes"></component>
    </keep-alive>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: 0,
    };
  },
  components: {
    // 首页
    CandidateList: () => import("./components/examList.vue"),
    // 考试详情
    CandidateDetail: () => import("./components/examDetail.vue"),
    // 答题详情
    AnswerDetail: () => import("./components/AnswerDetail.vue"),
    // 职称变更
    setTitleChange: () => import("./components/setTitleChange.vue"),
    // 人脸识别
    IdentifyFace: () => import("./components/IdentifyFace.vue"),
  },
  computed: {
    enter() {
      switch (this.isActive) {
        case 0:
          return "CandidateList";
          break;
        case 1:
          return "CandidateDetail";
          break;
        case 2:
          return "AnswerDetail";
          break;
        case 3:
          return "setTitleChange";
        case 4:
          return "IdentifyFace";
          break;
      }
      return "page";
    },
  },
  methods: {
    changes(index) {
      if (index == "0" && this.isActive == "1") {
        //这里代表新增返回
        console.log("新增返回");
        this.$children[0].Buriedpoint({
          code: "Examinee:candidateList:testDetail",
          parent_code: "Examinee:candidateList",
        });
      }
      this.isActive = index;
    },
  },
};
</script>
